import { useNavGate } from 'app/hooks/useNavGate'
import { useNavInputs } from 'app/hooks/useNavInputs'
import type { UserJson } from 'app/types/entities'
import { getNavSections } from 'lib/navSections'
import { filterNavSections } from 'lib/navVisibility'
import { groupRailSections, type RailConfig, type RailGroup } from 'lib/railSections'

export type RailSections = { rail: RailConfig; groups: RailGroup[]; inSection: boolean }

/**
 * Each rail's sections: the grouped sidebar's own row for it, filtered by the same gate, so the
 * rail shows a section exactly when the sidebar would have. Call from an `observer()` component
 * (the gate reads MobX state).
 */
export function useRailSections(user: UserJson, rails: RailConfig[]): RailSections[] {
  const { input } = useNavInputs(user)
  const gate = useNavGate(user)
  const footer = gate
    ? filterNavSections(getNavSections(input), gate).find((section) => section.id === `footer`)
    : undefined
  return rails.map((rail) => {
    const row = footer?.items.find((item) => item.name === rail.rowName)
    const groups = groupRailSections(row?.children ?? [], rail)
    return { rail, groups, inSection: groups.some((group) => group.items.some((item) => item.active)) }
  })
}
